import { render, staticRenderFns } from "./ProDView.vue?vue&type=template&id=d2bd9e9a&scoped=true&"
import script from "./ProDView.vue?vue&type=script&lang=js&"
export * from "./ProDView.vue?vue&type=script&lang=js&"
import style0 from "./ProDView.vue?vue&type=style&index=0&id=d2bd9e9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2bd9e9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VRow})
